import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import showAlert from '../alert/alertHandler';
import { v1 as uuidv1 } from 'uuid';

import badgeStylesRoute from '../resources/badgeStylesRoute.json';

import templateEscl from '../locales/es-CL/template.json';
import templateEsmx from '../locales/es-MX/template.json';
import templateEsco from '../locales/es-CO/template.json';
import templateEnus from '../locales/en-US/template.json';

/* locales */
import routesEscl from '../locales/es-CL/routes.json';
import routesEsmx from '../locales/es-MX/routes.json';
import routesEsco from '../locales/es-CO/routes.json';
import routesEnus from '../locales/en-US/routes.json';
import tripsEscl from '../locales/es-CL/trips.json';
import tripsEsmx from '../locales/es-MX/trips.json';
import tripsEsco from '../locales/es-CO/trips.json';
import tripsEnus from '../locales/en-US/trips.json';
import activitiesEscl from '../locales/es-CL/activities.json';
import activitiesEsmx from '../locales/es-MX/activities.json';
import activitiesEsco from '../locales/es-CO/activities.json';
import activitiesEnus from '../locales/en-US/activities.json';


import activityTableSchema from '../activities/activityTableSchema.json';
import tripTableSchema from '../trips/tripTableSchema.json';
import routeTableSchema from './routeTableSchema.json';

import activityTypes from '../resources/activityTypes.json';

/* exceptions */
import NoRouteException from '../exceptions/NoRouteException';
import InvalidRouteTimeException from '../exceptions/InvalidRouteTimeException';
import NoTripsException from '../exceptions/NoTripsException';
import NoActivitiesException from '../exceptions/NoActivitiesException';
import NoValidSpot from '../exceptions/NoValidSpot';

import Container from 'typedi';
import moment from 'moment';

/* services */
import RouteService from '../services/RouteService';
import DocumentService from '../services/DocumentService';
import ItemService from '../services/ItemService';
import SpotService from '../services/SpotService';
import TripService from '../services/TripService';
import ActivityService from '../services/ActivityService';
import DriverService from '../services/DriverService';
import VehicleService from '../services/VehicleService';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';

const baseCell = {
  class: 'text-center',
  tdClass: 'small',
  sortable: false,
};

export default {
  name: 'Template',
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  i18n: {
    messages: {
      'es-CL': {
        template: templateEscl,
        routes: routesEscl,
        trips: tripsEscl,
        activities: activitiesEscl,
      },
      'es-MX': {
        template: templateEsmx,
        routes: routesEsmx,
        trips: tripsEsmx,
        activities: activitiesEsmx,
      },
      'es-CO': {
        template: templateEsco,
        routes: routesEsco,
        trips: tripsEsco,
        activities: activitiesEsco,
      },
      'en-US': {
        template: templateEnus,
        routes: routesEnus,
        trips: tripsEnus,
        activities: activitiesEnus,
      },
    },
  },
  data() {
    return {
      isCrudBusy: false,
      resultValidation: null,
      rowsExcelTranform: [],
      optionsSpots: [],
      routeRowsExcel: null,
      tripRowsExcel: null,
      activityRowsExcel: null,
      fileExcel: null,
      isRouteTroncal: false,
      statusTemplate: false,
      vehicles: [],
      cargos: [],
      timeZone: null,
      scheduleTime: null,
      selectedTemplate: null,
      schedule: [],
      update: false,
      idTemplateUpdate: null,
      descripcionTemplate: null,
      nameTemplate: null,
      excelData: [],
      countryList: [],
      tags: [],
      user: null,
      cantRoutes: null,
      isFilterShown: false,
      isFilterClicked: false,
      isFilterApplied: false,
      dataAccess: null,
      loadSelected: null,
      shortCutPath: null,
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      currentPageRoutes: 1,
      perPageRoutes: 10,
      pageOptions: [10, 15, 20, 50, 100],
      templateData: [],
      isBusy: false,
      filters: {
        clientList: [],
        from: null,
        to: null,
        plateList: [],
        routeAssignmentList: [],
        routeDriverList: [],
      },
      options: {
        cantRouteList: [],
        nameList: [],
        userList: [],
      },
      name: null,
      badges: badgeStylesRoute,
      loadSection: [
        { charge: 10, percetage: '10%' },
        { charge: 20, percetage: '20%' },
        { charge: 30, percetage: '30%' },
        { charge: 40, percetage: '40%' },
        { charge: 50, percetage: '50%' },
        { charge: 60, percetage: '60%' },
        { charge: 70, percetage: '70%' },
        { charge: 80, percetage: '80%' },
        { charge: 90, percetage: '90%' },
        { charge: 100, percetage: '100%' },
      ],
      dynamicOptions: {
        destination: [],
        origin: [],
        vehicle: [],
        driver: [],
        itemType: [],
        spots: [],
        timeHours: [],
        timeMinutes: [],
      },
      sheduleList: [
        {
          id: 2,
          name: this.$t('template.modal.monday'),
        },
        {
          id: 3,
          name: this.$t('template.modal.tuesday'),
        },
        {
          id: 4,
          name: this.$t('template.modal.wednesday'),
        },
        {
          id: 5,
          name: this.$t('template.modal.thursday'),
        },
        {
          id: 6,
          name: this.$t('template.modal.friday'),
        },
        {
          id: 7,
          name: this.$t('template.modal.saturday'),
        },
        {
          id: 1,
          name: this.$t('template.modal.sunday'),
        },
      ],
      selectedTemplateToDelete: null
    };
  },
  async created() {
    // inyeccion de dependencias
    this.routeService = Container.get(RouteService);
    this.documentService = Container.get(DocumentService);
    this.itemService = Container.get(ItemService);
    this.spotService = Container.get(SpotService);
    this.driverService = Container.get(DriverService);
    this.activityService = Container.get(ActivityService);
    this.tripService = Container.get(TripService);
    this.vehicleService = Container.get(VehicleService);
    console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    await this.prepareData();
  },
  methods: {
    async getClients() {
      const urlClients = `${this.$store.getters.urlAPI}/api/client/all`;
      this.filters.clientList = [];
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlClients, config);
        response.data.data.forEach((element) => {
          this.filters.clientList.push(element);
        });
        this.filters.clientList.sort(function (a, b) {
          if (a.name[0] > b.name[0]) {
            return 1;
          }
          if (a.name[0] < b.name[0]) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getTags() {
      try {
        const url = `${this.$store.getters.urlAPI}/tag`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        let filterTag = response.data.data.filter((tag) => tag.enabled === true);
        return filterTag;
      } catch (e) {
        console.log(e);
      }
    },
    async getVehiclesData() {
      const urlVehicles = `${this.$store.getters.urlAPI}/api/vehicle?provider=true`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const vehiclePromise = await axios.get(urlVehicles, config);
        this.rawVehicles = vehiclePromise.data.data;
        this.rawVehicles.forEach((vehicle) => {
          vehicle.clientName = this.filters.clientList.find((element) => element.id === vehicle.idClient).name;
          vehicle.clientPlate = vehicle.plate + ' | ' + vehicle.clientName;
        });

        const cargoTypes = ['REMOLQUE', 'RAMPA', 'RAMPA FRIO', 'RAMPA SECA'];
        this.cargos = this.rawVehicles.filter((veh) => cargoTypes.includes(veh.vehicleType.description));
        this.vehicles = this.rawVehicles.filter((veh) => !cargoTypes.includes(veh.vehicleType.description));
      } catch (e) {
        console.log(e);
      }
    },
    async getDriversData() {
      const urlDrivers = `${this.$store.getters.urlAPI}/api/driver?provider=true`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let driverPromise = await axios.get(urlDrivers, config);
        this.filters.routeDriverList = driverPromise.data.data;
        this.filters.routeDriverList.forEach((driver) => {
          driver.clientName = this.filters.clientList.find((client) => driver.idClient === client.id).name;
          driver.driverNameClientName =
            this.transformWords(driver.firstName)  +
            ' ' +
            this.transformWords(driver.lastName) +
            ' | ' +
            driver.clientName;
          driver.driverName = this.transformWords(driver.firstName) + ' ' + this.transformWords(driver.lastName);
        });        
      } catch (e) {
        console.log(e);
      }
    },
    limitText(count) {
      return this.$t('template.search.limitText') + (count + 1);
    },
    confirmationSchedule() {
      console.log('schedule ...');
      let cronExpressionResult = this.cronExpressionProcess();
      console.log(cronExpressionResult);
      this.selectedTemplate.cronExpression = cronExpressionResult;
      console.log('template', this.selectedTemplate);
      let struture = {
        name: this.selectedTemplate.name,
        description: this.selectedTemplate.description,
        userNameLastName: this.selectedTemplate.userNameLastName,
        cronExpression: cronExpressionResult,
        status: this.selectedTemplate.status,
        timeZone: this.timeZone,
        routes: this.selectedTemplate.routes,
      };
      this.updateTemplate(struture, this.selectedTemplate.id);
      this.closeModal('template-schedule');
    },
    cronExpressionProcess() {
      console.log("mira ",this.schedule);
      //cron expression 0 10 ? * 1,2,3,4,5,6,7
      let timeArr = this.scheduleTime.split(':');
      let result = '0 ' + timeArr[1] + ' ' + timeArr[0] + ' ? * ';
      for (let i = 0; i < this.schedule.length; i++) {
        if (i === this.schedule.length - 1) {
          result += this.schedule[i].id;
        } else {
          result += this.schedule[i].id + ',';
        }
      }
      return result;
    },
    cleanFields() {
      this.schedule = [];
      this.scheduleTime = null;
    },
    scheduleTemplate(template) {
      this.cleanFields();
      this.selectedTemplate = template;
      this.loadDataSchedule();
      this.showModal('template-schedule');
      console.log(template);
    },
    loadDataSchedule() {
      if (this.selectedTemplate.cronExpression) {
        let cronArr = this.selectedTemplate.cronExpression.split('*');
        let days = cronArr[1].split(',');
        let time = cronArr[0].split(' ');
        this.scheduleTime = time[2] + ':' + time[1];
        this.setScheduleCron(days);
      }
    },
    setScheduleCron(days) {
      for (let day of days) {
        let option = this.sheduleList.find((s) => s.id == day);
        this.schedule.push(option);
      }
    },
    editExcelData(template) {
      this.update = true;
      this.idTemplateUpdate = template.id;
      this.statusTemplate = template.status;
      if (this.dataAccess.canNavTemplates && template.routes) {
        this.isRouteTroncal = true;
        this.excelData = this.processExcelDataRoute(
          template.routes,
          this.dynamicOptions.spots,
          this.vehicles,
          this.filters.routeDriverList,
          this.cargos,
        );
      } else if (this.dataAccess.canNavPlanification && template.planifications) {
        this.isRouteTroncal = false;
        this.excelData = this.processExcelDataPlanification(
          template.planifications,
          this.dynamicOptions.spots,
          this.vehicles,
          this.filters.routeDriverList,
          this.cargos,
        );
      }
      this.nameTemplate = template.name;
      this.descripcionTemplate = template.description;
      this.rowsExcelTranform = [];
      this.showModal('edit-massive-modal')
    },
    miliSecondsToString(miliseconds) {
      console.log('mili', miliseconds);
      var hour = Math.floor(miliseconds / 1000 / 3600);
      hour = hour < 10 ? '0' + hour : hour;
      var minute = Math.floor((miliseconds / 1000 / 60) % 60);
      minute = minute < 10 ? '0' + minute : minute;
      return hour + ':' + minute;
    },
    miliSecondsToStringHour(miliseconds) {
      console.log('mili', miliseconds);
      var hour = Math.floor(miliseconds / 1000 / 3600);
      hour = hour < 10 ? hour : hour;
      return hour;
    },
    miliSecondsToStringMinute(miliseconds) {
      console.log('mili', miliseconds);
      var minute = Math.floor((miliseconds / 1000 / 60) % 60);
      minute = minute < 10 ? minute : minute;
      return minute;
    },
    processExcelDataPlanification(planifications, spots, vehicles, driverList, cargos) {
      console.log('probando json generacion a la inversa ...', planifications);
      const responseExcelPlanifications = [];
      planifications.forEach((planification) => {
        const requestResources = planification.routesPlan[0].resources
          ? this.processExcelDataOperations(
              planification.routesPlan[0].resources,
              spots,
              vehicles,
              driverList,
              cargos,
              planifications.name,
            )
          : [];

        const dateStartTime = new Date(planification.executionDate);
        let timeHour = this.miliSecondsToStringHour(dateStartTime.getTime());
        console.log('hora', timeHour);
        let timeMinute = this.miliSecondsToStringMinute(dateStartTime.getTime());
        console.log('minuto', timeMinute);
        const body = {
          startTimeHours: timeHour,
          startTimeMinutes: timeMinute,
          loadTime:
            planification.loadTime && String(planification.loadTime) !== ''
              ? Math.round(Number(planification.loadTime) / 60)
              : 0,
          unloadTime:
            planification.unloadTime && String(planification.unloadTime) !== ''
              ? Math.round(Number(planification.unloadTime) / 60)
              : 0,
          name: planification.name,
          trips: requestResources,
        };
        responseExcelPlanifications.push(body);
      });
      return responseExcelPlanifications;
    },
    /**
     * metodo que transforma el nombre de spot si es que es temporal
     * @param {Json} address
     * @param {String} nullCase
     * @returns
     */
    transformNameAddress(address, nullCase) {
      let destination;
      if (address) {
        if (address.type !== 'Temporal') {
          destination = address.name;
        } else {
          const splitAddress = address.name.split(',');
          destination = `${splitAddress[0]}, ${splitAddress[1]}`;
        }
      } else {
        destination = nullCase;
      }
      return destination;
    },
    processExcelDataOperations(resources, spots, vehicles, driverList) {
      const responseExcelTrips = [];
      let rowNumberTrip = 0;
      resources = resources.filter((el) => {
        return el != null;
      });
      if (resources.length) {
        resources.forEach((trip) => {
          let specificVehicle = vehicles.find((v) => v.id == trip.idVehicleOperaciones);
          let specificDriver = driverList.find((d) => d.id == trip.idDriver);
          let specificCargo = null;
          trip.operations.forEach((operation) => {
            let tripDestinationSpot = null;
            let tripBody = null;
            console.log('spot en operation id', operation.spot.id);
            tripDestinationSpot = spots.find((s) => s.id === operation.spot.id);
            console.log('spot en operation', tripDestinationSpot);
            const tripDestinationName = this.transformNameAddress(tripDestinationSpot, '');

            console.log('vehicle ----', specificVehicle);
            console.log('driver ----', specificDriver);
            console.log('cargo ----', specificCargo);

            const specificActivity = activityTypes.find((e) => e.value === operation.type);
            tripBody = {
              Address: '',
              City: '',
              Country: '',
              State: '',
              Street: '',
              tripNumber: rowNumberTrip,
              tripDestination: tripDestinationName,
              type: 'Existente',
              timeEdit: Math.round(Number(trip.editTime / 60)),
              vehicle: specificVehicle ? specificVehicle.clientPlate : '',
              operator: specificDriver ? specificDriver.driverNameClientName : '',
              cargo: specificCargo ? specificCargo.clientPlate : '',
              extraData: operation.extraData ? operation.extraData.extraData1 : null,
              activityType: specificActivity.value,
              duration: Math.round(Number(operation.duration * 60)),
              money: operation.money ? operation.money : '',
              weight: operation.volume ? operation.volume : '',
              volume: operation.volume ? operation.volume : '',
            };
            responseExcelTrips.push(tripBody);
            rowNumberTrip++;
          });
        });
      }
      return responseExcelTrips;
    },
    processExcelDataRoute(routes, spots, vehicles, driverList, cargos) {
      console.log('probando json generacion a la inversa ...', routes);
      const responseExcelRoutes = [];
      let rowNumberTrip = 1,
        rowNumberActivity = 1;
      routes.forEach((route) => {
        console.log('spot en el ruta', route.origin);
        const originSpot = spots.find((s) => s.id === route.origin.id);
        const originName = this.transformNameAddress(originSpot, '');

        const requestTrips = route.trips
          ? this.processExcelDataTrip(
              route.trips,
              spots,
              rowNumberTrip,
              rowNumberActivity,
              vehicles,
              driverList,
              cargos,
            )
          : [];
        rowNumberTrip += route.trips.length;
        for (let trip of route.trips) {
          rowNumberActivity += trip.activities.length;
        }
        const dateStartTime = new Date(route.startDate);
        let timeHour = this.miliSecondsToStringHour(dateStartTime.getTime());
        console.log('hora', timeHour);
        let timeMinute = this.miliSecondsToStringMinute(dateStartTime.getTime());
        console.log('minuto', timeMinute);
        const body = {
          origin: originName,
          startTimeHours: timeHour,
          startTimeMinutes: timeMinute,
          loadTime: route.loadTime && String(route.loadTime) !== '' ? Math.round(Number(route.loadTime) / 60) : 0,
          unloadTime:
            route.unloadTime && String(route.unloadTime) !== '' ? Math.round(Number(route.unloadTime) / 60) : 0,
          name: route.name,
          trips: requestTrips,
        };
        responseExcelRoutes.push(body);
      });
      return responseExcelRoutes;
    },
    processExcelDataTrip(trips, spots, rowNumberTrip, rowNumberActivity, vehicles, driverList, cargos) {
      const responseExcelTrips = [];
      if (trips.length) {
        trips.forEach((trip) => {
          let tripDestinationSpot = null,
            specificVehicle = null,
            specificDriver = null,
            specificCargo = null;
          let tripBody = null;
          console.log('spot en el trip', trip.destination);
          tripDestinationSpot = spots.find((s) => s.id === trip.destination.id);
          const tripDestinationName = this.transformNameAddress(tripDestinationSpot, '');

          if (trip.setOperatorDirect) {
            specificVehicle = vehicles.find((v) => v.id == trip.setOperatorDirect.idVehicle);
            specificDriver = driverList.find((d) => d.id == trip.setOperatorDirect.idDriver);
            specificCargo = cargos.find((c) => c.id == trip.setOperatorDirect.idCargo);
          }
          console.log('vehicle ----', specificVehicle);
          console.log('driver ----', specificDriver);
          console.log('cargo ----', specificCargo);
          console.log('time ----', trip.editTime);
          const requestActivities = trip.activities
            ? this.processExcelDataActivity(trip.activities, rowNumberActivity)
            : [];
          rowNumberActivity += trip.activities.length;
          tripBody = {
            Address: '',
            City: '',
            Country: '',
            State: '',
            Street: '',
            tripNumber: rowNumberTrip,
            tripDestination: tripDestinationName,
            type: 'Existente',
            timeEdit: trip.editTime ? Math.round(Number(trip.editTime / 60)) : '',
            vehicle: specificVehicle ? specificVehicle.clientPlate : '',
            operator: specificDriver ? specificDriver.driverNameClientName : '',
            cargo: specificCargo ? specificCargo.clientPlate : '',
            extraData: trip.extraData ? trip.extraData.extraData1 : null,
            activities: requestActivities,
          };
          responseExcelTrips.push(tripBody);
          rowNumberTrip++;
        });
      }
      return responseExcelTrips;
    },
    processExcelDataActivity(activities, rowNumberActivity) {
      const responseExcelActivities = [];
      if (activities.length) {
        activities.forEach((activity) => {
          const activityBody = {
            activityNumber: rowNumberActivity,
            activityName: activity.name,
            activityType: this.staticOptions.activityType.find((e) => e.value === activity.type).text,
            duration: Math.round(Number(activity.duration / 60)),
            volume: activity.volume,
            weight: activity.weight,
            tag: activity.tags && activity.tags.length > 0 ? activity.tags[0].name : '',
          };
          responseExcelActivities.push(activityBody);
          rowNumberActivity++;
        });
      }
      return responseExcelActivities;
    },
    confirmation() {
      this.closeModal('template-modal');
      this.rowsExcelTranform = [];
      this.showModal('save-massive-modal')
    },
    checkStatus(template) {
      console.log('template', template);
      let struture = {
        name: template.name,
        description: template.description,
        userNameLastName: template.userNameLastName,
        cronExpression: template.cronExpression,
        status: template.status,
        routes: template.routes,
      };
      this.updateTemplate(struture, template.id);
    },
    processMassiveActivitySubmission(activities, activityTypes) {
      const requestActivities = [];
      if (activities.length) {
        activities.forEach((activity) => {
          const specificActivity = activityTypes.find((e) => e.text === activity.activityType);
          const tag = activity.tag ? [this.tags.find((filterTag) => filterTag.name === activity.tag)] : [];
          const activityBody = {
            name: activity.activityName,
            type: specificActivity.value,
            duration: Math.round(Number(activity.duration * 60)),
            weight: activity.volume ? activity.volume : '',
            volume: activity.volume ? activity.volume : '',
            tags: tag,
          };
          requestActivities.push(activityBody);
        });
      }
      return requestActivities;
    },
    processMassiveResourcesSubmission(
      trips,
      spots,
      activityTypes,
      vehicles,
      driverList,
      cargos,
      planificationNameTemp,
    ) {
      let requestResources = [];
      if (trips.length) {
        trips.forEach((trip) => {
          let tripDestinationSpot = null,
            specificVehicle = null,
            specificDriver = null,
            specificCargo = null;
          let resourceBody = null;
          if (trip.type == 'Temporal') {
            tripDestinationSpot = trip.destinationTemporal;
          } else {
            tripDestinationSpot = spots.find((s) => {
              //Verifico si el spot del listado es temporal
              if (s.type !== 'Temporal' && s.name === trip.tripDestination) {
                return s;
              }
              //Si es temporal entonces transformo el nombre del spot
              else if (s.type === 'Temporal') {
                const splitAddress = s.name.split(',');
                const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
                if (newName === trip.tripDestination) {
                  return s;
                }
              }
            });
          }
          specificVehicle = vehicles.find((v) => v.clientPlate === trip.vehicle);
          specificDriver = driverList.find((d) => d.driverNameClientName === trip.operator);
          specificCargo = cargos.find((c) => c.clientPlate === trip.cargo);

          console.log('vehículo select', specificVehicle);
          console.log('conductor', specificDriver);
          console.log('cargo select', specificCargo);

          if (trip.vehicle !== '' && trip.operator !== '') {
            let resourceFound = false;
            requestResources.forEach((element) => {
              if (element.idVehicleOperaciones == specificVehicle.id && element.idDriver == specificDriver.id) {
                resourceFound = true;
                let newOperation = {
                  name: trip.name,
                  spot: {
                    id: tripDestinationSpot.id,
                  },
                  type: activityTypes.find((e) => e.text === trip.activityType).value,
                  uuid: uuidv1(),
                  money: parseInt(trip.money),
                  volume: parseInt(trip.volume),
                  weight: parseInt(trip.weight),
                  planificationName: planificationNameTemp,
                };
                element.operations.push(newOperation);
                element.destination = {
                  id: tripDestinationSpot.id,
                };
                let totalMoneyTemp = 0.0;
                let totalVolumeTemp = 0.0;
                let totalWeightTemp = 0.0;
                element.operations.forEach((operation) => {
                  totalMoneyTemp += operation.money;
                  totalVolumeTemp += operation.volume;
                  totalWeightTemp += operation.weight;
                });
                element.totalMoney = totalMoneyTemp;
                element.totalVolume = totalVolumeTemp;
                element.totalWeight = totalWeightTemp;
              }
            });

            if (!resourceFound) {
              resourceBody = {
                plate: '',
                idDriver: specificDriver.id,
                totalTime: 0,
                driverName: '',
                operations: [
                  {
                    name: trip.name,
                    spot: {
                      id: tripDestinationSpot.id,
                    },
                    type: activityTypes.find((e) => e.text === trip.activityType).value,
                    uuid: uuidv1(),
                    money: parseInt(trip.money),
                    volume: parseInt(trip.volume),
                    weight: parseInt(trip.weight),
                    planificationName: planificationNameTemp,
                  },
                ],
                totalMoney: parseInt(trip.money),
                destination: null, //
                totalVolume: parseInt(trip.volume),
                totalWeight: parseInt(trip.weight),
                totalDistance: 0.0, //
                idVehicleOperaciones: specificVehicle.id,
              };
            }
          } else {
            resourceBody = {
              plate: '',
              idDriver: null,
              totalTime: 0,
              driverName: '',
              operations: [
                {
                  name: trip.name,
                  spot: {
                    id: tripDestinationSpot.id,
                  },
                  type: activityTypes.find((e) => e.text === trip.activityType).value,
                  uuid: uuidv1(),
                  money: parseInt(trip.money),
                  volume: parseInt(trip.volume),
                  weight: parseInt(trip.weight),
                  planificationName: planificationNameTemp,
                },
              ],
              totalMoney: parseInt(trip.money),
              destination: {
                id: tripDestinationSpot.id,
              },
              totalVolume: parseInt(trip.volume),
              totalWeight: parseInt(trip.weight),
              totalDistance: 0.0, //
              idVehicleOperaciones: null,
            };
          }
          requestResources.push(resourceBody);
        });
      }
      requestResources = requestResources.filter((el) => {
        return el != null;
      });
      console.log('ACA ESTA el RESOURCE con la estructura nueva', requestResources);
      return requestResources;
    },
    processMassiveTripSubmission(trips, spots, activityTypes, vehicles, driverList, cargos) {
      const requestTrips = [];
      if (trips.length) {
        // let rowNumber = 0;
        trips.forEach((trip) => {
          const timeEditTrip = trip.timeEdit;
          let tripDestinationSpot = null,
            specificVehicle = null,
            specificDriver = null,
            specificCargo = null;
          let tripBody = null;
          if (trip.type == 'Temporal') {
            tripDestinationSpot = trip.destinationTemporal;
          } else {
            tripDestinationSpot = spots.find((s) => {
              //Verifico si el spot del listado es temporal
              if (s.type !== 'Temporal' && s.name === trip.tripDestination) {
                return s;
              }
              //Si es temporal entonces transformo el nombre del spot
              else if (s.type === 'Temporal') {
                const splitAddress = s.name.split(',');
                const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
                if (newName === trip.tripDestination) {
                  return s;
                }
              }
            });
          }
          //copiar aca
          specificVehicle = vehicles.find((v) => v.clientPlate === trip.vehicle);
          specificDriver = driverList.find((d) => d.driverNameClientName === trip.operator);
          specificCargo = cargos.find((c) => c.clientPlate === trip.cargo);

          console.log('vehículo select', specificVehicle);
          console.log('conductor', specificDriver);
          console.log('cargo select', specificCargo);

          const requestActivities = trip.activities
            ? this.processMassiveActivitySubmission(trip.activities, activityTypes)
            : [];
          if (trip.vehicle !== '' && trip.operator !== '' && specificVehicle !== undefined && specificDriver !== undefined) {
            tripBody = {
              destination: {
                id: tripDestinationSpot.id,
              },
              editTime: timeEditTrip !== '' ? Math.round(Number(timeEditTrip * 60)) : null,
              setOperatorDirect: {
                idDriver: specificDriver.id,
                idVehicle: specificVehicle.id,
                idOperator: this.$store.getters.loggedUser['idUser'],
              },
              activities: requestActivities,
            };
            if (specificCargo !== undefined) {
              tripBody.setOperatorDirect.idCargo = specificCargo.id;
            }
          } else {
            tripBody = {
              destination: {
                id: tripDestinationSpot.id,
              },
              editTime: timeEditTrip !== '' ? Math.round(Number(timeEditTrip * 60)) : null,
              activities: requestActivities,
            };
          }
          tripBody.extraData = trip.extraData ? {
            extraData1: trip.extraData
          }: null;
          requestTrips.push(tripBody);
          // rowNumber++;
        });
      }
      console.log('ACA ESTA el TRIP con la estructura nueva', requestTrips);
      return requestTrips;
    },
    processMassivePlanificationSubmission(routes, spots, activityTypes, vehicles, driverList, cargos) {
      console.log('probando json generacion ...', routes);
      let requestPlanifications = [];
      routes.forEach((route) => {
        const requestResources = route.trips
          ? this.processMassiveResourcesSubmission(
              route.trips,
              spots,
              activityTypes,
              vehicles,
              driverList,
              cargos,
              routes.name,
            )
          : [];
        console.log('hora inicio', route.startTimeHours);
        console.log('minuto inicio', route.startTimeMinutes);
        let miliSeconds = (Number(route.startTimeHours) * 60 * 60 + Number(route.startTimeMinutes) * 60) * 1000;
        const routePlanBody = {
          id: null,
          name: route.name,
          state: null,
          idClient: null,
          loadTime: route.loadTime && String(route.loadTime) !== '' ? Math.round(Number(route.loadTime) * 60) : 0,
          unloadTime:
            route.unloadTime && String(route.unloadTime) !== '' ? Math.round(Number(route.unloadTime) * 60) : 0,
          resources: requestResources,
        };
        const routesPlanTemp = [];
        routesPlanTemp.push(routePlanBody);
        const body = {
          name: route.name,
          executionDate: miliSeconds,
          routesPlan: routesPlanTemp,
        };
        requestPlanifications.push(body);
      });
      requestPlanifications = requestPlanifications.filter((el) => {
        return el != null;
      });
      return requestPlanifications;
    },
    processMassiveRouteSubmission(routes, spots, activityTypes, vehicles, driverList, cargos) {
      console.log('probando json generacion ...', routes);
      const requestRoutes = [];
      routes.forEach((route) => {
        const originSpot = spots.find((s) => {
          //Verifico si el spot del listado es temporal
          if (s.type !== 'Temporal' && s.name === route.origin) {
            return s;
          }
          //Si es temporal entonces transformo el nombre del spot
          else if (s.type === 'Temporal') {
            const splitAddress = s.name.split(',');
            const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
            if (newName === route.origin) {
              return s;
            }
          }
        });
        const requestTrips = route.trips
          ? this.processMassiveTripSubmission(route.trips, spots, activityTypes, vehicles, driverList, cargos)
          : [];
        console.log('hora inicio', route.startTimeHours);
        console.log('minuto inicio', route.startTimeMinutes);
        console.log('Hora inicio numbre ', Number(route.startTimeHours));
        let miliSeconds = (Number(route.startTimeHours) * 60 * 60 + Number(route.startTimeMinutes) * 60) * 1000;
        const body = {
          origin: {
            id: originSpot.id,
          },
          startDate: miliSeconds,
          loadTime: route.loadTime && String(route.loadTime) !== '' ? Math.round(Number(route.loadTime) * 60) : 0,
          unloadTime:
            route.unloadTime && String(route.unloadTime) !== '' ? Math.round(Number(route.unloadTime) * 60) : 0,
          name: route.name,
          trips: requestTrips,
        };
        requestRoutes.push(body);
      });
      return requestRoutes;
    },
    async prepareSpotBody(trip) {
      try {
        let spotForm = {
          address: {
            city: trip.City,
            postalCode: null,
            state: trip.State,
            street: trip.Street,
            lat: null,
            lon: null,
            country: {
              id: this.countryList.find((country) => country.name === trip.Country).id,
              name: trip.Country,
            },
          },
          type: 'Temporal',
        };
        console.log('LLegando el spotform', spotForm);
        return spotForm;
      } catch (error) {
        console.log(error);
        showAlert(
          "Error",
          this.$t('routes.routeBatch.errors.invalidAddress'),
          "error",
        );
        throw error;
      }
    },
    async sendExcel() {
      this.isCrudBusy = true;
      if (!this.isRouteTroncal) {
        try {
          for (const element of this.rowsExcelTranform) {
            for (const trip of element.trips) {
              if (trip.tripDestination === this.$t('routes.routeBuilder.otros.crearNuevoDestino')) {
                let spotTemporal = await this.prepareSpotBody(trip);
                trip.destinationTemporal = spotTemporal;
                trip.type = 'Temporal';
              } else {
                trip.type = 'Existente';
              }
            }
          }
          this.dynamicOptions.spots = await this.spotService.getSpots();
          const result = await this.processMassivePlanificationSubmission(
            this.rowsExcelTranform,
            this.dynamicOptions.spots,
            this.staticOptions.activityType,
            this.vehicles,
            this.filters.routeDriverList,
            this.cargos,
          );
          let structurePost = {
            name: this.nameTemplate,
            description: this.descripcionTemplate,
            userNameLastName:
              this.$store.getters.loggedUser['firstName'] + ' ' + this.$store.getters.loggedUser['lastName'],
            timeZone: this.timeZone,
            routes: null,
            planifications: result,
          };
          console.log('rutas en el post ...', structurePost);
          if (this.update) {
            structurePost.status = this.statusTemplate;
            await this.updateTemplate(structurePost, this.idTemplateUpdate);
            this.closeModal('edit-massive-modal');
          } else {
            await this.insertTemplate(structurePost);
            this.closeModal('save-massive-modal');
          }
          this.handlePageChange();
        } catch (e) {
          console.log(e);
          showAlert(
            "Error",
            this.$t('routes.routeBatch.errors.generic'),
            "error"
          );
        }
      } else {
        try {
          for (const element of this.rowsExcelTranform) {
            for (const trip of element.trips) {
              if (trip.tripDestination === this.$t('routes.routeBuilder.otros.crearNuevoDestino')) {
                let spotTemporal = await this.prepareSpotBody(trip);
                trip.destinationTemporal = spotTemporal;
                trip.type = 'Temporal';
              } else {
                trip.type = 'Existente';
              }
            }
          }
          this.dynamicOptions.spots = await this.spotService.getSpots();
          const result = await this.processMassiveRouteSubmission(
            this.rowsExcelTranform,
            this.dynamicOptions.spots,
            this.staticOptions.activityType,
            this.vehicles,
            this.filters.routeDriverList,
            this.cargos,
          );
          let structurePost = {
            name: this.nameTemplate,
            description: this.descripcionTemplate,
            userNameLastName:
              this.$store.getters.loggedUser['firstName'] + ' ' + this.$store.getters.loggedUser['lastName'],
            timeZone: this.timeZone,
            routes: result,
          };
          console.log('rutas en el post ...', structurePost);
          if (this.update) {
            structurePost.status = this.statusTemplate;
            await this.updateTemplate(structurePost, this.idTemplateUpdate);
            this.closeModal('edit-massive-modal');
          } else {
            await this.insertTemplate(structurePost);
            this.closeModal('save-massive-modal');
          }
          this.handlePageChange();
        } catch (e) {
          console.log(e);
          showAlert(
            "Error",
            this.$t('routes.routeBatch.errors.generic'),
            "error"
          );
        }
      }
      this.isCrudBusy = false;
    },
    async updateTemplate(body, id) {
      const urlTemplate = `${this.$store.getters.urlAPI}/template/${id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.patch(urlTemplate, body, config);

        if (response.data.status) {
          console.log(response.data.data);
          showAlert(
            this.$t('template.alertMessages.success.title'),
            this.$t('template.alertMessages.success.message'),
            'success',
          );
        }
        this.handlePageChange();
      } catch (error) {
        showAlert('Error', error.response.data);
      }
    },
    async deleteTemplate(id) {
      const urlTemplate = `${this.$store.getters.urlAPI}/template/${id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.delete(urlTemplate, config);

        if (response.data.status) {
          console.log(response.data.data);
          showAlert(
            this.$t('template.alertMessages.success.title'),
            this.$t('template.alertMessages.success.message'),
            'success',
          );
        }
        this.handlePageChange();
      } catch (error) {
        showAlert('Error', error.response.data);
      }
    },
    async insertTemplate(body) {
      const urlTemplate = `${this.$store.getters.urlAPI}/template`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(urlTemplate, body, config);

        if (response.data.status) {
          showAlert(
            this.$t('template.alertMessages.success.title'),
            this.$t('template.alertMessages.success.message'),
            'success',
          );
          return response.data.data;
        }
      } catch (error) {
        console.log('error en el post template', error);
      }
    },
    createTemplate() {
      console.log('aca vamos ...');
      this.showModal('template-modal');
      this.refreshDataTemplate();
    },
    refreshDataTemplate() {
      this.nameTemplate = null;
      this.descripcionTemplate = null;
      this.update = false;
      this.idTemplateUpdate = null;
    },
    preSubmitValidation(validRows, showError, highlightError, setSaveButtonAvailability) {
      setSaveButtonAvailability(false);
      try {
        if (!this.isRouteTroncal) {
          this.routeService.validateMassivePlanificationUploadPreSubmission(validRows);
        } else {
          this.routeService.validateMassiveRouteUploadPreSubmission(validRows);
        }
        return true;
      } catch (e) {
        if (e instanceof NoRouteException) {
          showError(this.$t('routes.routeBatch.errors.noRoute'));
        } else if (e instanceof InvalidRouteTimeException) {
          showError(this.$t('routes.routeBatch.errors.pastLimitDates', { limitDate: 72 }));
          highlightError(null, e.identifier + 1);
          setSaveButtonAvailability(true);
        } else if (e instanceof NoTripsException) {
          showError(this.$t('routes.routeBatch.errors.noTrip'));
          setSaveButtonAvailability(true);
        } else if (e instanceof NoActivitiesException) {
          showError(this.$t('routes.routeBatch.errors.noActivity'));
          setSaveButtonAvailability(true);
        } else if (e instanceof NoValidSpot) {
          showError(this.$t('routes.routeBatch.errors.notEnoughParameters'));
          setSaveButtonAvailability(true);
        }
        return false;
      }
    },
    async getAddressBySpot(spotId) {
      try {
        const currentSpot = this.dynamicOptions.spots.find((spot) => spot.id === spotId);
        return currentSpot.address;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    /* metodos de carga de datos complementarios */
    async getDrivers() {
      const includeOnlyUsers = false;
      const drivers = await this.driverService.getDrivers(includeOnlyUsers);
      this.dynamicOptions.driver = drivers;
      this.dynamicOptions.driver.forEach((driver) => {
        if (!driver.firstName) {
          console.log('testing', driver);
        }
        driver.fullName = this.transformWords(driver.firstName) + '  ' + this.transformWords(driver.lastName);
      });
    },
    async getVehicles() {
      const vehicles = await this.vehicleService.getVehicles();
      this.dynamicOptions.vehicle = vehicles;
    },
    async getCountryList() {
      var url = `${this.$store.getters.urlAPI}/api/country`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const response = await axios.get(url, config);
      console.log(response);
      response.data.data.forEach((element) => {
        if (element.iso === 'CL' || element.iso === 'MX') {
          this.countryList.push({
            id: element.id,
            name: element.name,
            iso: element.iso,
          });
        }
      });
      if (this.countryList.length > 0) {
        console.log('Listado de paises listo!');
        this.sortCountryList();
      } else {
        console.log('Listado de paises no listo. No se pueden crear ordenes!');
      }
    },
    sortCountryList() {
      this.countryList.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a y b son iguales.
        return 0;
      });
    },
    /**
     * Metodo que deriva a otra vista dado ciertos parametros.
     * Prioridad al cambiar de vista: Preparar filtrado instantaneo por id de ruta.
     * @param {Integer} routeId, es la id de la ruta seleccionada.
     * @param {String} path, es el nombre de la vista a la que se desea ir.
     * @returns A la nueva vista.
     */
    async goToAnotherPage(routeId, path) {
      this.isButtonClicked = true;
      await this.$store.commit('saveShortCutPathOrigin', 'Route fulfillment');
      await this.$store.commit('saveIdRouteFlash', routeId);
      return this.$router.push({ name: path });
    },
    async initRoute(route) {
      const url = `${this.$store.getters.urlAPI}/route/${route.idRoute}/onGoing`;
      console.log('url', url);
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      console.log('config', config);
      const body = {};
      try {
        await axios.patch(url, body, config);
        showAlert(
          this.$t('routeAssignment.alertMessages.success.title'),
          this.$t('routeAssignment.alertMessages.success.message'),
        );
        this.handlePageChange();
      } catch (e) {
        showAlert('Error', e.response.data);
      }
    },

    async prepareInstantFilter() {
      this.shortCutPath = await this.$store.getters.shortCutPathOrigin;
      if (this.shortCutPath) {
        this.idRoute = [];
        this.idRoute.push(this.$route.query.idRoute || (await this.$store.getters.idRouteFlash));
        this.$store.commit('cleanIdRouteFlash');
        this.$store.commit('cleanShortCutPathOrigin');
      }
    },

    async prepareData() {
      this.isBusy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      if (this.dataAccess.canNavTemplates) {
        this.isRouteTroncal = true;
      } else if (this.dataAccess.canNavPlanification) {
        this.isRouteTroncal = false;
      }
      await this.prepareInstantFilter();
      await this.getTemplate();
      await this.populateTemplateNameFilter();
      await this.populateQuantityFilter();
      await this.populateUserFilter();
      this.dynamicOptions.spots = await this.spotService.getSpots();
      this.dynamicOptions.timeHours = await this.setTimeHours();
      this.dynamicOptions.timeMinutes = await this.setTimeMinutes();
      console.log('minutes', this.dynamicOptions.timeMinutes);
      console.log('hours', this.dynamicOptions.timeHours);
      await this.getCountryList();
      await this.getClients(); //Llena el listado de clientes
      await this.getVehiclesData(); //Obtiene los vehículos. Depende del listado de clientes
      await this.getDriversData(); //Obtiene los conductores. Depende del listado de clientes
      this.tags = await this.getTags();
      this.isBusy = false;
    },
    async setTimeHours() {
      let result = [];
      if (!this.dataAccess.canNavPlanification) {
        for (let i = 0; i <= 72; i++) {
          let option = {
            text: String(i),
            value: i,
          };
          result.push(option);
        }
      } else {
        for (let i = 0; i <= 23; i++) {
          let option = {
            text: String(i),
            value: i,
          };
          result.push(option);
        }
      }
      return result;
    },
    async setTimeMinutes() {
      let result = [];
      for (let i = 0; i <= 59; i++) {
        let option = {
          text: String(i),
          value: i,
        };
        result.push(option);
      }
      return result;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de nombre de rutas para el filtro.
     */
    populateRouteNameFilter() {
      //Obtiene todos los nombres de las rutas que lo posean.
      this.routesAssignment.forEach((route) => {
        this.options.nameList.push(route.name);
      });
      //Remueve elementos repetidos del resultado.
      this.options.nameList = this.options.nameList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },

    populateTemplateNameFilter() {
      //Obtiene todos los nombres de las rutas que lo posean.
      this.templateData.forEach((template) => {
        this.options.nameList.push(template.name);
      });
      //Remueve elementos repetidos del resultado.
      this.options.nameList = this.options.nameList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },

    populateQuantityFilter() {
      //Obtiene todos los nombres de las rutas que lo posean.
      this.templateData.forEach((template) => {
        this.options.cantRouteList.push(template.quantity);
      });
      //Remueve elementos repetidos del resultado.
      this.options.cantRouteList = this.options.cantRouteList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },

    populateUserFilter() {
      //Obtiene todos los nombres de las rutas que lo posean.
      this.templateData.forEach((template) => {
        this.options.userList.push(template.userNameLastName);
      });
      //Remueve elementos repetidos del resultado.
      this.options.userList = this.options.userList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },

    async getTemplate() {
      const urlTemplate = `${this.$store.getters.urlAPI}/template`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let templatePromise = await axios.get(urlTemplate, config);
        this.templateData = templatePromise.data.data;
        this.populateTemplate();
      } catch (e) {
        console.log(e);
      }
    },
    populateTemplate() {
      for (let template of this.templateData) {
        const startDateTemp = new Date(template.executedAt);
        const startSeconds = startDateTemp.getTime();
        const startExecuteDate = new Date(startSeconds);
        console.log(template.executedAt);

        const updateDateTemp = new Date(template.modifiedAt);
        const updateSeconds = updateDateTemp.getTime();
        const updateDate = new Date(updateSeconds);

        template.quantity = template.routes.length;
        template.startExecuteDate =
          template.executedAt !== undefined ? moment(startExecuteDate).format('DD/MM/YY HH:mm:ss') : '-';
        template.updateDate = moment(updateDate).format('DD/MM/YY HH:mm:ss');
      }
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    templateToDelete(template) {
      this.selectedTemplateToDelete = template;
      this.$bvModal.show('delete-template');
    },
    async handlePageChange() {
      this.isBusy = true;
      await this.getTemplate();
      this.isBusy = false;
    },
    dateToSeconds(element) {
      const date = new Date(element);
      return date.getTime();
    },
    onBeforeValidation(schema, content, locale, contents, schemaKey, ignoreEmpty, updateCell) {
      if (schemaKey == 'activities') {
        for (let i = 0; i < content.length; i++) {
          let row = content[i];
          if (row.activityType === 'DELIVERY' || row.activityType === 'ENTREGA') {
            updateCell(schemaKey, i, 'activityType', this.$t('activities.formulario.campos.typeOptions.DELIVERY'));
          }
          if (row.activityType === 'COLLECTION' || row.activityType === 'RECOGIDA') {
            updateCell(schemaKey, i, 'activityType', this.$t('activities.formulario.campos.typeOptions.COLLECTION'));
          }
          if (row.activityType === 'VISIT' || row.activityType === 'VISITA') {
            updateCell(schemaKey, i, 'activityType', this.$t('activities.formulario.campos.typeOptions.VISIT'));
          }
        }
      }
      return true;
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    /**
     * Metodo que retorna a la vista anterior.
     * @param {String} shortCutPath, nombre de la ruta.
     * @returns vista anterior.
     */
    returnToPage(shortCutPath) {
      return this.$router.push({ name: shortCutPath });
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    /**
     * Metodo que limpia el filtrado.
     */
    cleanFilter() {
      this.name = null;
      this.user = null;
      this.cantRoutes = null;
    },
    async buildExcelPro() {
      //Metodo que llena el dropdown del excel con datos de tipo de vehículos extra (por cliente)
      console.log('PRO PRO PRO ROUTE');
      const wb = new ExcelJS.Workbook();
      if (!this.isRouteTroncal) {
        //mundo nuevo
      } else {
        let ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.routes'));
        let headers = [
          { header: this.$t('routes.routeBatch.campos.routeName'), key: 'name', width: 40 },
          { header: this.$t('routes.routeBatch.campos.origin'), key: 'origin', width: 30 },
          { header: this.$t('routes.routeBatch.campos.startTimeHour'), key: 'startTimeHours', width: 30 },
          { header: this.$t('routes.routeBatch.campos.startTimeMinute'), key: 'startTimeMinutes', width: 30 },
          { header: this.$t('routes.routeBatch.campos.loadTime'), key: 'loadTime', width: 30 },
          { header: this.$t('routes.routeBatch.campos.unloadtime'), key: 'unloadTime', width: 30 },
        ];
        ws.columns = headers;
  
        for (let i = 0; i < this.dynamicOptions.spots.length; i++) {
          if (this.dynamicOptions.spots[i].type !== 'Temporal') {
            ws.getCell(`$BB$${i+1}`).value = this.dynamicOptions.spots[i].name;
          } else {
            const splitAddress = this.dynamicOptions.spots[i].name.split(',');
            console.log('temporal  ' + splitAddress)
            // ws.getCell(`$BB$${i+1}`).value = `${splitAddress[0]}, ${splitAddress[1]}`;
          }
        }
  
        for (let i = 0; i < 24; i++) {
          ws.getCell(`$BC$${i+1}`).value = i;
        }

        for (let i = 0; i < 60; i++) {
          ws.getCell(`$BD$${i+1}`).value = i;
        }

        for (let i = 2; i < 200; i++) {
          ws.getCell(`B${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BB$1:$BB$${this.dynamicOptions.spots.length}`],
          };
          ws.getCell(`C${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BC$1:$BC$${24}`],
          };
          ws.getCell(`D${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BD$1:$BD$${60}`],
          };
        }
  
        ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.trips'));
        headers = [
          { header: this.$t('routes.routeBatch.campos.routeName'), key: 'name', width: 40 },
          { header: this.$t('routes.routeBatch.campos.tripNumber'), key: 'tripNumber', width: 15 },
          { header: this.$t('routes.routeBatch.campos.destination'), key: 'tripDestination', width: 30 },
          { header: this.$t('routes.routeBatch.campos.timeEdit'), key: 'timeEdit', width: 30 },
          { header: this.$t('routes.routeBatch.campos.vehicle'), key: 'vehicle', width: 30 },
          { header: this.$t('routes.routeBatch.campos.operator'), key: 'operator', width: 30 },
          { header: this.$t('routes.routeBatch.campos.cargo'), key: 'cargo', width: 30 },
          { header: this.$t('routes.routeBatch.campos.extraData'), key: 'extraData', width: 30 },
          { header: this.$t('routes.routeBatch.campos.street'), key: 'Street', width: 30 },
          { header: this.$t('routes.routeBatch.campos.city'), key: 'City', width: 30 },
          { header: this.$t('routes.routeBatch.campos.state'), key: 'State', width: 30 },
          { header: this.$t('routes.routeBatch.campos.country'), key: 'Country', width: 30 },
          { header: this.$t('routes.routeBatch.campos.address'), key: 'Address', width: 30 },
        ];

        ws.columns = headers;
  
        /* let H1 = ws.getCell('H1');
        H1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        H1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.extraDataDescription')},
          ],
          editAs: "twoCells"
        }; */

        let parentWorksheet = this.$t('routes.routeBatch.sheets.routes');
        const fromReference = 2;
        const toReference = 202;
        for (let i = 2; i <= 202; i++) {
          ws.getCell('ZZ' + i).value = {
            formula: `=IFERROR(INDEX('${
              parentWorksheet
            }'!$A$${fromReference}:$A$${toReference}, MATCH(0,COUNTIF($ZZ$1:ZZ${i - 1}, '${
              parentWorksheet
            }'!$A$${fromReference}:$A$${toReference}), 0)),"")`,
            result: 200,
            shareType: 'array',
            ref: `ZZ${i}:ZZ${i}`,
          };
        }
  
        for (let i = 0; i < 198; i++) {
          ws.getCell(`$B$${i+2}`).value = i + 1;
        }
        
        for (let i = 0; i < this.dynamicOptions.spots.length; i++) {
          if (this.dynamicOptions.spots[i].type !== 'Temporal') {
            ws.getCell(`$BC$${i+1}`).value = this.dynamicOptions.spots[i].name;
          } else {
            const splitAddress = this.dynamicOptions.spots[i].name.split(',');
            console.log('temporal  ' + splitAddress);
            //ws.getCell(`$BC$${i+1}`).value = `${splitAddress[0]}, ${splitAddress[1]}`;
          }
        }
        
        for (let i = 0; i < this.vehicles.length; i++) {
          ws.getCell(`$BE$${i+1}`).value = this.vehicles[i].clientPlate;
        }
        for (let i = 0; i < this.filters.routeDriverList.length; i++) {
          ws.getCell(`$BF$${i+1}`).value = this.filters.routeDriverList[i].driverNameClientName;
        }
        for (let i = 0; i < this.cargos.length; i++) {
          ws.getCell(`$BG$${i+1}`).value = this.cargos[i].clientPlate;
        }
        for (let i = 0; i < this.countryList.length; i++) {
          ws.getCell(`$BK$${i+1}`).value = this.countryList[i].name;
        }
        for (let i = 2; i < 200; i++) {
          ws.getCell(`A${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`=OFFSET($ZZ$2,0,0,199-COUNTBLANK($ZZ$2:$ZZ$201),1)`],
          };
          ws.getCell(`C${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BC$1:$BC$${this.dynamicOptions.spots.length}`],
          };

          if (this.vehicles.length > 0) {
            ws.getCell(`E${i}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [`$BE$1:$BE$${this.vehicles.length}`],
            };
          }

          if (this.filters.routeDriverList.length > 0) {
            ws.getCell(`F${i}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [`$BF$1:$BF$${this.filters.routeDriverList.length}`],
            };
          }

          if (this.cargos.length > 0) {
            ws.getCell(`G${i}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [`$BG$1:$BG$${this.cargos.length}`],
            };
          }
  
          ws.getCell(`K${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BK$1:$BK$${this.countryList.length}`],
          };
        }
  
        ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.activities'));
        headers = [
          { header: this.$t('routes.routeBatch.campos.tripNumber'), key: 'tripNumber', width: 15 },
          { header: this.$t('routes.routeBatch.campos.activityName'), key: 'activityName', width: 40 },
          { header: this.$t('routes.routeBatch.campos.activityNumber'), key: 'activityNumber', width: 20 },
          { header: this.$t('routes.routeBatch.campos.activityType'), key: 'activityType', width: 15 },
          { header: this.$t('routes.routeBatch.campos.duration'), key: 'duration', width: 20 },
          { header: this.$t('routes.routeBatch.campos.volume'), key: 'volume', width: 15 },        
          { header: this.$t('routes.routeBatch.campos.weight'), key: 'weight', width: 15 },
          { header: this.$t('routes.routeBatch.campos.tag'), key: 'tag', width: 30 },
        ];
        ws.columns = headers;
  
        parentWorksheet = this.$t('routes.routeBatch.sheets.trips');      
        for (let i = 2; i <= 202; i++) {
          ws.getCell('ZZ' + i).value = {
            formula: `=IFERROR(INDEX('${
              parentWorksheet
            }'!$B$${fromReference}:$B$${toReference}, MATCH(0,COUNTIF($ZZ$1:ZZ${i - 1}, '${
              parentWorksheet
            }'!$B$${fromReference}:$B$${toReference}), 0)),"")`,
            result: 200,
            shareType: 'array',
            ref: `ZZ${i}:ZZ${i}`,
          };
        }
  
        for (let i = 0; i < 198; i++) {
          ws.getCell(`$C$${i+2}`).value = i + 1;
        }
  
        for (let i = 0; i < this.staticOptions.activityType.length; i++) {
          ws.getCell(`$BD$${i+1}`).value = this.$t(this.staticOptions.activityType[i].text);
        }
  
        for (let i = 0; i < this.tags.length; i++) {
          ws.getCell(`$BH$${i+1}`).value = this.$t(this.tags[i].name);
        }
        
        for (let i = 2; i < 200; i++) {
          ws.getCell(`A${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`=OFFSET($ZZ$2,0,0,199-COUNTBLANK($ZZ$2:$ZZ$201),1)`],
          };
          ws.getCell(`D${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BD$1:$BD$${this.staticOptions.activityType.length}`],
          };
          if (this.tags.length > 0) {
            ws.getCell(`H${i}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [`$BH$1:$BH$${this.tags.length}`],
            };
          }
        }  
      }

      const buffer = await wb.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileExtension = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      
      saveAs(blob, 'excel_template' + fileExtension);
    },
    async buildExcelProEdit() {
      //Metodo que llena el dropdown del excel con datos de tipo de vehículos extra (por cliente)
      console.log('PRO PRO EDIT ROUTE');
      const wb = new ExcelJS.Workbook();
      if (!this.isRouteTroncal) {
        //mundo nuevo
      } else {
        let ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.routes'));
        let headers = [
          { header: this.$t('routes.routeBatch.campos.routeName'), key: 'name', width: 40 },
          { header: this.$t('routes.routeBatch.campos.origin'), key: 'origin', width: 30 },
          { header: this.$t('routes.routeBatch.campos.startTimeHour'), key: 'startTimeHours', width: 30 },
          { header: this.$t('routes.routeBatch.campos.startTimeMinute'), key: 'startTimeMinutes', width: 30 },
          { header: this.$t('routes.routeBatch.campos.loadTime'), key: 'loadTime', width: 30 },
          { header: this.$t('routes.routeBatch.campos.unloadtime'), key: 'unloadTime', width: 30 },
        ];
        ws.columns = headers;
  
        for (let i = 0; i < this.dynamicOptions.spots.length; i++) {
          if (this.dynamicOptions.spots[i].type !== 'Temporal') {
            ws.getCell(`$BB$${i+1}`).value = this.dynamicOptions.spots[i].name;
          } else {
            const splitAddress = this.dynamicOptions.spots[i].name.split(',');
            console.log('temporal  ' + splitAddress);
            //ws.getCell(`$BB$${i+1}`).value = `${splitAddress[0]}, ${splitAddress[1]}`;
          }
        }
          
        for (let i = 0; i < 24; i++) {
          ws.getCell(`$BC$${i+1}`).value = i;
        }

        for (let i = 0; i < 60; i++) {
          ws.getCell(`$BD$${i+1}`).value = i;
        }

        for (let i = 2; i < 200; i++) {
          ws.getCell(`B${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BB$1:$BB$${this.dynamicOptions.spots.length}`],
          };
          ws.getCell(`C${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BC$1:$BC$${24}`],
          };
          ws.getCell(`D${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BD$1:$BD$${60}`],
          };
        }

        for (let i = 0; i < this.excelData.length; i++) {
          ws.getCell(`$A$${i+2}`).value = this.excelData[i].name;
          ws.getCell(`$B$${i+2}`).value = this.excelData[i].origin;
          ws.getCell(`$C$${i+2}`).value = this.excelData[i].startTimeHours;
          ws.getCell(`$D$${i+2}`).value = this.excelData[i].startTimeMinutes;
          ws.getCell(`$E$${i+2}`).value = this.excelData[i].loadTime;
          ws.getCell(`$F$${i+2}`).value = this.excelData[i].unloadTime;
        }

        ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.trips'));
        headers = [
          { header: this.$t('routes.routeBatch.campos.routeName'), key: 'name', width: 40 },
          { header: this.$t('routes.routeBatch.campos.tripNumber'), key: 'tripNumber', width: 15 },
          { header: this.$t('routes.routeBatch.campos.destination'), key: 'tripDestination', width: 30 },
          { header: this.$t('routes.routeBatch.campos.timeEdit'), key: 'timeEdit', width: 30 },
          { header: this.$t('routes.routeBatch.campos.vehicle'), key: 'vehicle', width: 30 },
          { header: this.$t('routes.routeBatch.campos.operator'), key: 'operator', width: 30 },
          { header: this.$t('routes.routeBatch.campos.cargo'), key: 'cargo', width: 30 },
          { header: this.$t('routes.routeBatch.campos.extraData'), key: 'extraData', width: 30 },
          { header: this.$t('routes.routeBatch.campos.street'), key: 'Street', width: 30 },
          { header: this.$t('routes.routeBatch.campos.city'), key: 'City', width: 30 },
          { header: this.$t('routes.routeBatch.campos.state'), key: 'State', width: 30 },
          { header: this.$t('routes.routeBatch.campos.country'), key: 'Country', width: 30 },
          { header: this.$t('routes.routeBatch.campos.address'), key: 'Address', width: 30 },
        ];
        ws.columns = headers;

        /* let H1 = ws.getCell('H1');
        H1.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFFF00'},
        };
        H1.note = {
          texts: [
            {'font': {'bold': true, 'size': 12, 'name': 'Calibri', 'family': 2, 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.optional')},
            {'font': {'size': 12, 'name': 'Calibri', 'scheme': 'minor'}, 'text': this.$t('routes.routeBatch.cellComments.extraDataDescription')},
          ],
          editAs: "twoCells"
        }; */
  
        let parentWorksheet = this.$t('routes.routeBatch.sheets.routes');
        const fromReference = 2;
        const toReference = 202;
        for (let i = 2; i <= 202; i++) {
          ws.getCell('ZZ' + i).value = {
            formula: `=IFERROR(INDEX('${
              parentWorksheet
            }'!$A$${fromReference}:$A$${toReference}, MATCH(0,COUNTIF($ZZ$1:ZZ${i - 1}, '${
              parentWorksheet
            }'!$A$${fromReference}:$A$${toReference}), 0)),"")`,
            result: 200,
            shareType: 'array',
            ref: `ZZ${i}:ZZ${i}`,
          };
        }
  
        for (let i = 0; i < 198; i++) {
          ws.getCell(`$B$${i+2}`).value = i + 1;
        }
        
        for (let i = 0; i < this.dynamicOptions.spots.length; i++) {
          if (this.dynamicOptions.spots[i].type !== 'Temporal') {
            ws.getCell(`$BC$${i+1}`).value = this.dynamicOptions.spots[i].name;
          } else {
            const splitAddress = this.dynamicOptions.spots[i].name.split(',');
            console.log('temporal  ' + splitAddress);
            //ws.getCell(`$BC$${i+1}`).value = `${splitAddress[0]}, ${splitAddress[1]}`;
          }
        }
        
        for (let i = 0; i < this.vehicles.length; i++) {
          ws.getCell(`$BE$${i+1}`).value = this.vehicles[i].clientPlate;
        }
        for (let i = 0; i < this.filters.routeDriverList.length; i++) {
          ws.getCell(`$BF$${i+1}`).value = this.filters.routeDriverList[i].driverNameClientName;
        }
        for (let i = 0; i < this.cargos.length; i++) {
          ws.getCell(`$BG$${i+1}`).value = this.cargos[i].clientPlate;
        }
        for (let i = 0; i < this.countryList.length; i++) {
          ws.getCell(`$BK$${i+1}`).value = this.countryList[i].name;
        }

        for (let i = 2; i < 200; i++) {
          ws.getCell(`A${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`=OFFSET($ZZ$2,0,0,199-COUNTBLANK($ZZ$2:$ZZ$201),1)`],
          };
          ws.getCell(`C${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BC$1:$BC$${this.dynamicOptions.spots.length}`],
          };
          
          if (this.vehicles.length > 0) {
            ws.getCell(`E${i}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [`$BE$1:$BE$${this.vehicles.length}`],
            };
          }
          if (this.filters.routeDriverList.length > 0) {
            ws.getCell(`F${i}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [`$BF$1:$BF$${this.filters.routeDriverList.length}`],
            };
          }
          if (this.cargos.length > 0) {
            ws.getCell(`G${i}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [`$BG$1:$BG$${this.cargos.length}`],
            };
          }
  
          ws.getCell(`K${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BK$1:$BK$${this.countryList.length}`],
          };
        }
  
        let index = 0;
        for (let i = 0; i < this.excelData.length; i++) {
          for (let j = 0; j < this.excelData[i].trips.length; j++) {
            ws.getCell(`$A$${index+2}`).value = this.excelData[i].name;
            ws.getCell(`$C$${index+2}`).value = this.excelData[i].trips[j].tripDestination;
            ws.getCell(`$D$${index+2}`).value = this.excelData[i].trips[j].timeEdit;
            ws.getCell(`$E$${index+2}`).value = this.excelData[i].trips[j].vehicle;
            ws.getCell(`$F$${index+2}`).value = this.excelData[i].trips[j].operator;
            ws.getCell(`$G$${index+2}`).value = this.excelData[i].trips[j].cargo;
            ws.getCell(`$H$${index+2}`).value = this.excelData[i].trips[j].extraData;
            ws.getCell(`$I$${index+2}`).value = this.excelData[i].trips[j].Street;
            ws.getCell(`$J$${index+2}`).value = this.excelData[i].trips[j].City;
            ws.getCell(`$K$${index+2}`).value = this.excelData[i].trips[j].State;
            ws.getCell(`$L$${index+2}`).value = this.excelData[i].trips[j].Country;
            ws.getCell(`$M$${index+2}`).value = this.excelData[i].trips[j].Address;
            index++;
          }
        }

        ws = wb.addWorksheet(this.$t('routes.routeBatch.sheets.activities'));
        headers = [
          { header: this.$t('routes.routeBatch.campos.tripNumber'), key: 'tripNumber', width: 15 },
          { header: this.$t('routes.routeBatch.campos.activityName'), key: 'activityName', width: 40 },
          { header: this.$t('routes.routeBatch.campos.activityNumber'), key: 'activityNumber', width: 20 },
          { header: this.$t('routes.routeBatch.campos.activityType'), key: 'activityType', width: 15 },
          { header: this.$t('routes.routeBatch.campos.duration'), key: 'duration', width: 20 },
          { header: this.$t('routes.routeBatch.campos.volume'), key: 'volume', width: 15 },        
          { header: this.$t('routes.routeBatch.campos.weight'), key: 'weight', width: 15 },
          { header: this.$t('routes.routeBatch.campos.tag'), key: 'tag', width: 30 },
        ];
        ws.columns = headers;
  
        parentWorksheet = this.$t('routes.routeBatch.sheets.trips');      
        for (let i = 2; i <= 202; i++) {
          ws.getCell('ZZ' + i).value = {
            formula: `=IFERROR(INDEX('${
              parentWorksheet
            }'!$B$${fromReference}:$B$${toReference}, MATCH(0,COUNTIF($ZZ$1:ZZ${i - 1}, '${
              parentWorksheet
            }'!$B$${fromReference}:$B$${toReference}), 0)),"")`,
            result: 200,
            shareType: 'array',
            ref: `ZZ${i}:ZZ${i}`,
          };
        }
  
        for (let i = 0; i < 198; i++) {
          ws.getCell(`$C$${i+2}`).value = i + 1;
        }
  
        for (let i = 0; i < this.staticOptions.activityType.length; i++) {
          ws.getCell(`$BD$${i+1}`).value = this.$t(this.staticOptions.activityType[i].text);
        }
  
        for (let i = 0; i < this.tags.length; i++) {
          ws.getCell(`$BH$${i+1}`).value = this.$t(this.tags[i].name);
        }
        
        index = 0;
        let tripIndex = 0;
        for (let i = 0; i < this.excelData.length; i++) {
          for (let j = 0; j < this.excelData[i].trips.length; j++) {
            for (let x = 0; x < this.excelData[i].trips[j].activities.length; x++) {              
              ws.getCell(`$A$${index+2}`).value = tripIndex + 1;
              ws.getCell(`$B$${index+2}`).value = this.excelData[i].trips[j].activities[x].activityName;
              ws.getCell(`$D$${index+2}`).value = this.excelData[i].trips[j].activities[x].activityType;
              ws.getCell(`$E$${index+2}`).value = this.excelData[i].trips[j].activities[x].duration;
              ws.getCell(`$F$${index+2}`).value = this.excelData[i].trips[j].activities[x].volume;
              ws.getCell(`$G$${index+2}`).value = this.excelData[i].trips[j].activities[x].weight;
              ws.getCell(`$H$${index+2}`).value = this.excelData[i].trips[j].activities[x].tag;
              index++;
            }
            tripIndex++;
          }
        }

        for (let i = 2; i < 200; i++) {
          ws.getCell(`A${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`=OFFSET($ZZ$2,0,0,199-COUNTBLANK($ZZ$2:$ZZ$201),1)`],
          };
          ws.getCell(`D${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`$BD$1:$BD$${this.staticOptions.activityType.length}`],
          };
          if (this.tags.length > 0) {
            ws.getCell(`H${i}`).dataValidation = {
              type: 'list',
              allowBlank: true,
              formulae: [`$BH$1:$BH$${this.tags.length}`],
            };
          }
        }  
      }

      const buffer = await wb.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileExtension = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      
      saveAs(blob, 'excel_template' + fileExtension);
    },
    addfile(event) {
      this.file = event.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result;
        let data = new Uint8Array(this.arrayBuffer);
        let arr = new Array();
        for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        let bstr = arr.join('');
        let workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });

        if (!this.isRouteTroncal) {
          //mundo nuevo
        } else {
          this.routeRowsExcel = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { raw: true });
          this.tripRowsExcel = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[1]], { raw: true });
          this.activityRowsExcel = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[2]], { raw: true });
          this.readFileExcelTroncal();
        }
      };
    },
    async readFileExcelTroncal() {
      this.rowsExcelTranform = [];
      this.resultValidation = null;
      this.prepareFileExcelTroncal();
      let index = 0;
      for (let route of this.routeRowsExcel) {
        if (route.name || route.origin 
          || route.startTimeHours || route.startTimeMinutes 
          || route.loadTime || route.unloadTime) {
          this.resultValidation = this.validateRouteRequiredExcelTroncal(route,index);
          if (!this.resultValidation) {
            route.trips = [];
            this.rowsExcelTranform.push(route);
          } else {
            break;
          }
          index += 1;
        }
      }

      let suggestedTripNumber = [];
      if (!this.resultValidation) {
        index = 0;
        for (let trip of this.tripRowsExcel) {
          if(trip.name  
            || trip.tripDestination || trip.timeEdit 
            || trip.vehicle || trip.operator || trip.cargo || trip.extraData  
            || trip.Street || trip.City 
            || trip.State || trip.Country) {
            this.resultValidation = this.validateTripRequiredExcelTroncal(trip,index);
            if (!this.resultValidation) {
              for (let route of this.rowsExcelTranform) {
                if (trip.name === route.name) {
                  const currentSpot = this.dynamicOptions.spots.find((s) => {
                    //Verifico si el spot del listado es temporal
                    if (s.type !== 'Temporal' && s.name === trip.tripDestination) {
                      return s;
                    }
                    //Si es temporal entonces transformo el nombre del spot
                    else if (s.type === 'Temporal') {
                      const splitAddress = s.name.split(',');
                      const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
                      if (newName === trip.tripDestination) {
                        return s;
                      }
                    }
                  });
                  if (currentSpot == undefined) {
                    trip.Address =  null;
                  } else {
                    const address = await this.getAddressBySpot(currentSpot.id);
                    trip.Address = address.street + ', ' + address.city + ', ' + address.state;
                  }
                  trip.activities = [];
                  route.trips.push(trip);
                  suggestedTripNumber.push(trip.tripNumber);
                }            
              }
            } else {
              break;
            }
            index += 1;
          }
        }
      }

      if (!this.resultValidation) {
        index = 0;
        for (let activity of this.activityRowsExcel) {
          if (activity.tripNumber || activity.activityName 
            || activity.activityType 
            || activity.duration || activity.volume 
            || activity.weight || activity.tag) {
            this.resultValidation = this.validateActivityRequiredExcelTroncal(activity,index,suggestedTripNumber);
            if (!this.resultValidation) {
              for (let route of this.rowsExcelTranform) {
                for (let trip of route.trips) {
                  if (trip.tripNumber === activity.tripNumber) {
                    trip.activities.push(activity);
                  }
                }   
              }
            } else {
              break;
            }
            index += 1;
          }
        }
      }      

      if (!this.resultValidation) {
        this.resultValidation = this.checkRouteDuplicationExcelTroncal(this.rowsExcelTranform);
      }

      if (!this.resultValidation) {
        index = 0;
        for (let route of this.rowsExcelTranform) {
          this.resultValidation = this.validateRouteConditionTripExcelTroncal(route.trips,index);
          if (this.resultValidation) {
            break;
          }
          index += 1;
        }
      }

      if (!this.resultValidation) {
        let breakMain = false;
        for (let route of this.rowsExcelTranform) {
          for (let trip of route.trips) {
            this.resultValidation = this.validateTripConditionActivityExcelTroncal(trip.activities, trip.tripNumber);
            if (this.resultValidation) {
              breakMain = true;
              break;
            }
          }
          if (breakMain) {
            break;
          }
        }
      }

      if (this.resultValidation) {
        this.missRequiredData = true;
        showAlert('Error', this.resultValidation.message, 'error');
        if (this.update) {
          this.closeModal('edit-massive-modal')
        } else {
          this.closeModal('save-massive-modal')
        }
      }
    },
    validateRouteRequiredExcelTroncal(row, index) {
      let rowProblem = null;
      if (row.name == null || row.name == undefined || row.name == '') {
        rowProblem = {
          status: 'FAIL',
          message: 'Nombre de ruta en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }

      if (rowProblem == null && (
        this.dynamicOptions.spots.find((element) => {
          //Verifico si el spot del listado es temporal
          if (element.type !== 'Temporal' && element.name === row.origin) {
            return element;
          }
          //Si es temporal entonces transformo el nombre del spot
          else if (element.type === 'Temporal') {
            const splitAddress = element.name.split(',');
            const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
            if (newName === row.origin) {
              return element;
            }
          }        
        }) === undefined 
        || row.origin == null || row.origin == undefined || row.origin == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Origen de ruta en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }

      const hours = [];
      const minutes = [];
      for (let i = 0; i < 24; i++) {
        hours.push(i);
      }
      for (let i = 0; i < 60; i++) {
        minutes.push(i);
      }

      if (rowProblem == null && (hours.find((element) => element === row.startTimeHours) === undefined || row.startTimeHours === null || row.startTimeHours === undefined || row.startTimeHours === '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Hora de inicio hora de ruta en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      
      if (rowProblem == null && (minutes.find((element) => element === row.startTimeMinutes) === undefined || row.startTimeMinutes === null || row.startTimeMinutes === undefined || row.startTimeMinutes === '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Hora de inicio minuto de ruta en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      return rowProblem;
    },

    checkRouteDuplicationExcelTroncal(routes) {
      let rowProblem = null;
      const result = this.findDuplicates(routes, "name");
      if (result.length > 0) {
        rowProblem = {
          status: 'FAIL',
          message: 'Rutas en la plantilla no pueden tener el mismo nombre. Rutas con conflicto: ' + result,
        };
      }
      return rowProblem;
    },

    // Encuentra duplicados
    findDuplicates(array, key) {
      const counts = array.reduce((acc, obj) => {
        acc[obj[key]] = (acc[obj[key]] || 0) + 1;
        return acc;
      }, {});

      return Object.keys(counts).filter(name => counts[name] > 1);
    },
    
    validateRouteConditionTripExcelTroncal(trips,index) {
      let rowProblem = null;
      if (trips.length == 0) {
        rowProblem = {
          status: 'FAIL',
          message: 'Ruta en fila ' + (index + 1).toString() + ' no posee viajes. Asígnale al menos un viaje o elimina dicha ruta',
        };
      }
      return rowProblem;
    },

    validateTripConditionActivityExcelTroncal(activities,index) {
      let rowProblem = null;
      if (activities.length == 0) {
        rowProblem = {
          status: 'FAIL',
          message: 'Viaje en fila ' + (index).toString() + ' no posee actividades. Asígnale al menos una actividad o elimina dicho viaje',
        };
      }
      return rowProblem;
    },

    //!aca agregar validacion de rutas
    validateTripRequiredExcelTroncal(row, index) {
      let rowProblem = null;
      if (row.name == null || row.name == undefined || row.name == '' || this.rowsExcelTranform.find((element) => element.name === row.name) === undefined) {
        rowProblem = {
          status: 'FAIL',
          message: 'Nombre de ruta de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      if (rowProblem == null && (row.tripNumber !== null && row.tripNumber == undefined && row.tripNumber == '')){
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de viaje en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }      
      if (rowProblem == null && (this.dynamicOptions.spots.find((element) => {
        //Verifico si el spot del listado es temporal
        if (element.type !== 'Temporal' && element.name === row.tripDestination) {
          return element;
        }
        //Si es temporal entonces transformo el nombre del spot
        else if (element.type === 'Temporal') {
          const splitAddress = element.name.split(',');
          const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
          if (newName === row.tripDestination) {
            return element;
          }
        }
      }) === undefined || row.tripDestination == null || row.tripDestination == undefined || row.tripDestination == '')) {
        if (this.$t('routes.routeBuilder.otros.crearNuevoDestino') !== row.tripDestination) {
          rowProblem = {
            status: 'FAIL',
            message: 'Destino de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      if (rowProblem == null && (row.vehicle !== null && row.vehicle == undefined && row.vehicle == '')){
        if (this.vehicles.find((element) => element.clientPlate === row.vehicle) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Vehiculo de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      if (rowProblem == null && (row.operator !== null && row.operator == undefined && row.operator == '')){
        if (this.filters.routeDriverList.find((element) => element.driverNameClientName === row.operator) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Conductor de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      if (rowProblem == null && (row.cargo !== null && row.cargo == undefined && row.cargo == '')){
        if (this.cargos.find((element) => element.clientPlate === row.cargo) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Cargo de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      if (rowProblem == null && (row.Country !== null && row.Country !== undefined && row.Country !== '')){
        if (this.countryList.find((element) => element.name === row.Country) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Vehiculo de viaje en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      return rowProblem;
    },
    validateActivityRequiredExcelTroncal(row, index, suggestedTripNumber) {
      let rowProblem = null;
      if (row.tripNumber == null || row.tripNumber == undefined || row.tripNumber == '' || suggestedTripNumber.find((element) => element === row.tripNumber) === undefined) {
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de viaje de actividad en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      if (rowProblem == null && (row.activityName == null || row.activityName == undefined || row.activityName == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Nombre de actividad en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }
      if (rowProblem == null && (row.activityNumber == null || row.activityNumber == undefined || row.activityNumber == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Numero de actividad en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }
      if (rowProblem == null && (this.staticOptions.activityType.find((element) => element.text === row.activityType) === undefined || row.activityType == null || row.activityType == undefined || row.activityType == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Tipo de actividad en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
        };
      }
      if (rowProblem == null && (row.duration == null || row.duration == undefined || row.duration == '')) {
        rowProblem = {
          status: 'FAIL',
          message: 'Duracion de actividad en fila ' + (index + 1).toString() + ' es obligatorio',
        };
      }
      if (rowProblem == null && (row.tag !== null && row.tag !== undefined && row.tag !== '')){
        if (this.tags.find((element) => element.name === row.tag) === undefined) {
          rowProblem = {
            status: 'FAIL',
            message: 'Atributo de actividad en fila ' + (index + 1).toString() + ' no sigue las opciones sugeridas',
          };
        }
      }
      return rowProblem;
    },
    async prepareFileExcelTroncal() {
      //Rutas
      let name = this.$t('routes.routeBatch.campos.routeName');
      let origin = this.$t('routes.routeBatch.campos.origin');
      let startTimeHours = this.$t('routes.routeBatch.campos.startTimeHour');
      let startTimeMinutes = this.$t('routes.routeBatch.campos.startTimeMinute');
      let loadTime = this.$t('routes.routeBatch.campos.loadTime');
      let unloadTime = this.$t('routes.routeBatch.campos.unloadtime');

      for (let row of this.routeRowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === name) {
            row.name = value;
          } else if (key.trim() === origin) {
            row.origin = value;
          } else if (key.trim() === startTimeHours) {
            row.startTimeHours = value;
          }  else if (key.trim() === startTimeMinutes) {
            row.startTimeMinutes = value;
          }  else if (key.trim() === loadTime) {
            row.loadTime = value;
          }  else if (key.trim() === unloadTime) {
            row.unloadTime = value;
          } 
        });
      }

      //Viajes
      name = this.$t('routes.routeBatch.campos.routeName');
      let tripNumber = this.$t('routes.routeBatch.campos.tripNumber');
      let tripDestination = this.$t('routes.routeBatch.campos.destination');
      let timeEdit = this.$t('routes.routeBatch.campos.timeEdit');
      let vehicle = this.$t('routes.routeBatch.campos.vehicle');
      let operator = this.$t('routes.routeBatch.campos.operator');
      let cargo = this.$t('routes.routeBatch.campos.cargo');
      let extraData = this.$t('routes.routeBatch.campos.extraData')
      let Street = this.$t('routes.routeBatch.campos.street');
      let City = this.$t('routes.routeBatch.campos.city');
      let State = this.$t('routes.routeBatch.campos.state');
      let Country = this.$t('routes.routeBatch.campos.country');
      let Address = this.$t('routes.routeBatch.campos.address');

      for (let row of this.tripRowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === name) {
            row.name = value;
          } else if (key.trim() === tripNumber) {
            row.tripNumber = value;
          } else if (key.trim() === tripDestination) {
            row.tripDestination = value;
          } else if (key.trim() === timeEdit) {
            row.timeEdit = value;
          } else if (key.trim() === vehicle) {
            row.vehicle = value;
          } else if (key.trim() === operator) {
            row.operator = value;
          } else if (key.trim() === cargo) {
            row.cargo = value;
          } else if (key.trim() === extraData) {
            row.extraData = value;
          } else if (key.trim() === Street) {
            row.Street = value;
          } else if (key.trim() === City) {
            row.City = value;
          } else if (key.trim() === State) {
            row.State = value;
          } else if (key.trim() === Country) {
            row.Country = value;
          } else if (key.trim() === Address) {
            row.Address = value;
          }
        });
      }

      //Actividades
      tripNumber = this.$t('routes.routeBatch.campos.tripNumber');
      let activityName = this.$t('routes.routeBatch.campos.activityName');
      let activityNumber = this.$t('routes.routeBatch.campos.activityNumber');
      let activityType = this.$t('routes.routeBatch.campos.activityType');
      let duration = this.$t('routes.routeBatch.campos.duration');
      let volume = this.$t('routes.routeBatch.campos.volume');
      let weight = this.$t('routes.routeBatch.campos.weight');
      let tag = this.$t('routes.routeBatch.campos.tag');

      for (let row of this.activityRowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === tripNumber) {
            row.tripNumber = value;
          } else if (key.trim() === activityName) {
            row.activityName = value;
          } else if (key.trim() === activityNumber) {
            row.activityNumber = value;
          } else if (key.trim() === activityType) {
            row.activityType = value;
          } else if (key.trim() === duration) {
            row.duration = value;
          } else if (key.trim() === volume) {
            row.volume = value;
          } else if (key.trim() === weight) {
            row.weight = value;
          } else if (key.trim() === tag) {
            row.tag = value;
          }
        });
      }
    },
  },
  computed: {
    staticOptions() {
      return {
        activityType: activityTypes.map((e) => ({
          ...e,
          text: this.$t(e.text),
        })),
      };
    },
    locale() {
      return this.$i18n.locale.substring(0, 2).toUpperCase();
    },
    fields() {
      return routeTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        class: 'text-center',
        tdClass: e.key === 'routeIcon' ? 'text-center' : 'small',
        sortable: !['shortcuts', 'actions'].includes(e.key),
      }));
    },
    fieldsTrips() {
      return tripTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        class: 'text-center',
        tdClass: 'small',
        sortable: false,
      }));
    },
    fieldsActivities() {
      return activityTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        ...baseCell,
      }));
    },
    rows() {
      return this.templateData.length;
    },
    fromManagement() {
      return !!this.$route.query.fromManagement;
    },

    templateFiltered() {
      this.templateFilteredData = this.templateData;
      this.isFilterApplied = false;
      if (this.name && this.name.length > 0) {
        this.templateFilteredData = this.templateFilteredData.filter((template) => {
          if (template.name !== undefined) {
            return this.name.some((nameTemplate) => {
              if (nameTemplate != undefined) {
                return nameTemplate === template.name;
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.user && this.user.length > 0) {
        this.templateFilteredData = this.templateFilteredData.filter((template) => {
          if (template.userNameLastName !== undefined) {
            return this.user.some((userTemplate) => {
              if (userTemplate != undefined) {
                return userTemplate === template.userNameLastName;
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      return this.templateFilteredData;
    },
    templateFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'name',
          label: this.$t('template.table.nameRoute'),
          sortable: true,
          ...common,
        },
        {
          key: 'quantity',
          label: this.$t('template.table.cantRoute'),
          sortable: true,
          ...common,
        },
        {
          key: 'startExecuteDate',
          label: this.$t('template.table.dateCreated'),
          sortable: true.valueOf,
          ...common,
        },
        {
          key: 'updateDate',
          label: this.$t('template.table.dateLastUpdate'),
          sortable: true,
          ...common,
        },
        {
          key: 'userNameLastName',
          label: this.$t('template.table.user'),
          sortable: true,
          ...common,
        },
        {
          key: 'select',
          label: this.$t('template.table.activeTemplate'),
          ...common,
        },

        {
          key: 'actions',
          label: this.$t('template.table.actions'),
          ...common,
        },
      ];
    },
  },
};
